<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'

@Component({
  name: 'AdminMesureUniteList'
})

export default class AdminMesureUniteList extends AdminList<AloDbMesureUnite> {  
 
  get itemTypeName() {
    return "MesureUnite"
  }     
}
</script>